/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/
function initTrendSlider() {
	var $trends = $('.trendSlider').flickity({
		cellAlign: 'left',
		contain: true,
		prevNextButtons: true,
		pageDots: false,
		on: {
			ready: function () {
				$('.trendSlider-cell').attr('aria-hidden', 'false');
			},
			change: function () {
				$('.trendSlider-cell').attr('aria-hidden', 'false');
			}
		}
	});
	$trends.flickity('resize');
}
$(function () {
	if ($('#uber').hasClass('homepage')) {
		//News and Events Feed
		if ($().matchHeight) {
			$('.matchHeight').matchHeight();
		}
	}

	if ($(window).width() >= 753) {
		initTrendSlider();
	}
});
$(window).on('resize', function () {
	if ($(window).width() >= 753) {
		if (!$('.trendSlider').is('.flickity-enabled')) {
			initTrendSlider();
		}
	} else {
		if ($('.trendSlider').is('.flickity-enabled')) {
			$('.trendSlider').flickity('destroy');
		}
	}
});
